import { css } from 'react-emotion';
import { colors, animationTransition } from '../../variables';

export namespace styles {
  export const radioWrapper = css({
    display: 'flex',
    alignItems: 'center'
  });
  export const dot = (checked: boolean) =>
    css({
      position: 'relative',
      marginRight: '8px',
      display: 'inline-block',
      height: '20px',
      width: '20px',
      cursor: 'pointer',
      appearance: 'none',
      outline: 'none',
      '::before': {
        content: '" "',
        display: 'block',
        position: 'absolute',
        left: 0,
        top: 0,
        height: 20,
        width: 20,
        borderRadius: '50%',
        backgroundColor: 'white',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: colors.light
      },
      '::after': {
        opacity: checked ? 1 : 0,
        content: '" "',
        display: 'block',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        height: 12,
        width: 12,
        borderRadius: '50%',
        backgroundColor: '#514a6ecc',
        transition: animationTransition('opacity')
      }
    });
}
